


















































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import {
  ADD_UPLOADED_IMAGE,
  CLEAR_UPLOADED_IMAGE,
  FETCH_VESSEL,
  SET_PREVIEW_MODE,
  SET_VESSEL_ITEM_ATTRIBUTE,
  SET_VESSEL_ITEM_RELATION,
  UPDATE_VESSEL
} from '@/store/vessels';
import { SearchResultItem } from '@/types/SearchResultItem';
import { Vessel } from '@/types/entities/Vessel';
import { Image } from '@/types/entities/Image';
import { mapMutations } from 'vuex';
import { validationMixin } from 'vuelidate';
import { minValue, required } from 'vuelidate/lib/validators';
import { SEARCH_MARINAS } from '@/store/marinas';
import { mixins } from 'vue-class-component';
import FileUploader from '@/components/FileUploader.vue';
import TrashIcon from '@/svg/trash.svg';
import UiKitTextarea from '@/components/UiKit/UiKitTextarea.vue';
import UiKitSelect from '@/components/UiKit/UiKitSelect.vue';
import UiKitInput from '@/components/UiKit/UiKitInput.vue';
import ConfirmVesselDeletingModal from '@/components/ConfirmVesselDeletingModal.vue';
import HelpersMixin from '@/mixins/helpers.mixin';
import CrossIcon from '@/svg/cross.svg';
import CheckIcon from '@/svg/check.svg';
import UiKitNewWindowLink from '@/components/UiKit/UiKitNewWindowLink.vue';

@Component({
  components: {
    UiKitNewWindowLink,
    ConfirmVesselDeletingModal,
    UiKitInput,
    UiKitSelect,
    UiKitTextarea,
    FileUploader,
    TrashIcon,
    CrossIcon,
    CheckIcon
  },
  methods: {
    ...mapMutations({
      setAttribute: SET_VESSEL_ITEM_ATTRIBUTE,
      setRelation: SET_VESSEL_ITEM_RELATION
    })
  },
  mixins: [ validationMixin ],
  validations: {
    vessel: {
      attributes: {
        price: { required, minValue: minValue(100) },
        year: { required, minValue: minValue(1900) },
        model: { required },
        length: { required, minValue: minValue(0) },
        beam: { required, minValue: minValue(0) },
        description: { required },
        sellerInfo: { required },
      },
      relationships: {
        make: {
          data: {
            id: { required }
          }
        },
        internalColor: {
          data: {
            id: { required }
          }
        },
        externalColor: {
          data: {
            id: { required }
          }
        },
        fuelType: {
          data: {
            id: { required }
          }
        },
        marina: {
          data: {
            id: { required }
          }
        }
      }
    }
  }
})
export default class UpdateListing extends mixins(HelpersMixin, Vue) {
  protected errorMessages = [];

  protected isSuccess = false;

  public beforeRouteEnter(_: any, __: any, next: any) {
    next((vm: UpdateListing) => {
      const previewMode = vm.$store.state.vessels.previewMode;

      vm.$store.commit(SET_PREVIEW_MODE, false);

      if (previewMode) {
        return next();
      }

      vm.$store.commit(CLEAR_UPLOADED_IMAGE);
      vm.$store.dispatch(SEARCH_MARINAS);

      return vm.$store.dispatch(FETCH_VESSEL, vm.$route.params.id)
        .then(() => next());
    });
  }

  public mounted() {
    window.scrollTo(0, 0);
  }

  get vessel(): SearchResultItem<Vessel> {
    return this.$store.state.vessels.item.data;
  }

  get imagesCount(): number {
    return this.$store.state.vessels.uploadedImages.length + this.vessel.relationships.vesselImages.data.length;
  }

  protected addImage(image: Image) {
    this.$store.commit(ADD_UPLOADED_IMAGE, image);
  }

  protected update() {
    this.isSuccess = false;

    this.$v.$touch();

    if (this.$v.$error) {
      this.$nextTick(() => {
        const validationErrorElement = document.getElementsByClassName('form-error');

        if (validationErrorElement.length) {
          validationErrorElement[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });

      return;
    }

    return this.$store
      .dispatch(UPDATE_VESSEL)
      .then(() => this.$store.dispatch(FETCH_VESSEL, this.$route.params.id))
      .then(() => this.$store.commit(CLEAR_UPLOADED_IMAGE))
      .then(() => this.isSuccess = true)
      .then(() => this.$nextTick(() => {
        const successMessageElement = document.getElementsByClassName('marketplace-listing-success');

        if (successMessageElement.length) {
          successMessageElement[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }))
      .catch((error) => this.errorMessages = error.response.data.errors.map((e: any) => e.detail));
  }
}
